import React from 'react';
import PropTypes from 'prop-types';

// Test for this component is included in cards organism test
const Card = ({ item }) => (
  <>
    <h2>{item.title}</h2>
  </>
);

Card.propTypes = {
  item: PropTypes.shape({ title: PropTypes.string }).isRequired,
};

export default Card;
